<script>
    import * as Utils from '@js/modules/utils';
    import I18n from '@js/modules/translations';
    import Computation from '@js/modules/computation';

    import {poiStore} from '@js/stores/poiStore';

    import PlanFilterItem from '@js/components/plan/filter/PlanFilterItem.svelte';

    const {
        allFilters
    } = $props();

    const initialFilters = {
        dateTypes: new Set(allFilters.dateTypes),
        rideTypes: new Set(allFilters.rideTypes),
        levels: new Set(allFilters.levels),
        distance: new Set(),
        duration: new Set()
    };

    poiStore.selectedFilters = {
        dateTypes: null,
        rideTypes: null,
        levels: null,
        distance: null,
        duration: null
    };

    const _updateFilters = Utils.debounce((selectedFilters) => {
        poiStore.selectedFilters = selectedFilters;

        poiStore.map.fetchPlanPOIs(poiStore.selectedFilters);
    }, 400);

    const onFilterChange = (filterType, filterName, filterData, checked) => {
        const selectedFilters = {...poiStore.selectedFilters};

        if (filterType === 'range') {
            if ((1 - allFilters[filterName].min / filterData[0]) < 0.08 && (1 - filterData[1] / allFilters[filterName].max) < 0.08) {
                selectedFilters[filterName] = undefined;
            } else {
                selectedFilters[filterName] = new Set(filterData);
            }
        } else if (filterType === 'switch') {
            if (filterData) {
                selectedFilters[filterName] = filterData;
            } else {
                selectedFilters[filterName] = undefined;
            }
        } else if (filterType === 'select') {
            if (!selectedFilters[filterName]) {
                selectedFilters[filterName] = new Set(initialFilters[filterName]);
            }

            if (checked) {
                selectedFilters[filterName].add(filterData.id);
            } else {
                selectedFilters[filterName].delete(filterData.id);
            }
        }

        _updateFilters(selectedFilters);
    };
</script>

{#if $poiStore.planPois.length}
    <div class="mt-2 mx-4">
        <div class="flex items-center flex-wrap justify-start gap-3">
            <PlanFilterItem type="switch"
                            name={I18n.t('js.ride.plan.index.filters.associated')}
                            elementId="associated"
                            elements={I18n.t('js.ride.plan.enums.ride_associated')}
                            selectedElements={$poiStore.selectedFilters.associated || initialFilters.associated}
                            onFilterChange={onFilterChange}/>

            <PlanFilterItem type="select"
                            name={I18n.t('js.ride.plan.index.filters.date_type')}
                            elementId="dateTypes"
                            elements={allFilters.dateTypes.map((dateType) => ({
                                      id: dateType,
                                      name: I18n.t('js.ride.plan.enums.plan_date_type')[dateType]
                                  }))}
                            selectedElements={$poiStore.selectedFilters.dateTypes || initialFilters.dateTypes}
                            onFilterChange={onFilterChange}/>

            <PlanFilterItem type="select"
                            name={I18n.t('js.ride.plan.index.filters.ride_type')}
                            elementId="rideTypes"
                            elements={allFilters.rideTypes.map((rideType) => ({
                                                  id: rideType,
                                                  name: I18n.t('js.ride.enums.ride_type')[rideType]
                                              }))}
                            selectedElements={$poiStore.selectedFilters.rideTypes || initialFilters.rideTypes}
                            onFilterChange={onFilterChange}/>

            {#if allFilters.distance.min && allFilters.distance.max}
                <PlanFilterItem type="range"
                                name={I18n.t('js.ride.plan.index.filters.distance')}
                                elementId="distance"
                                elements={[allFilters.distance.min, allFilters.distance.max]}
                                elementFormatter={(element) => Computation.formatDistance(element, {
                            smartUnit: true,
                            kUnit: false,
                            decimalLimit: 1
                        })}
                                selectedElements={$poiStore.selectedFilters.distance || initialFilters.distance}
                                onFilterChange={onFilterChange}/>
            {/if}

            {#if allFilters.duration.min && allFilters.duration.max}
                <PlanFilterItem type="range"
                                name={I18n.t('js.ride.plan.index.filters.duration')}
                                elementId="duration"
                                elements={[allFilters.duration.min, allFilters.duration.max]}
                                elementFormatter={(element) => Computation.formatDuration(element, {withSeconds: false})}
                                selectedElements={$poiStore.selectedFilters.duration || initialFilters.duration}
                                onFilterChange={onFilterChange}/>
            {/if}

            {#if allFilters.levels?.length}
                <PlanFilterItem type="select"
                                name={I18n.t('js.ride.plan.index.filters.level')}
                                elementId="levels"
                                elements={allFilters.levels.map((level) => ({
                                                  id: level,
                                                  name: I18n.t('js.ride.enums.level')[level]
                                              }))}
                                selectedElements={$poiStore.selectedFilters.levels || initialFilters.levels}
                                onFilterChange={onFilterChange}/>
            {/if}
        </div>
    </div>
{/if}
